import type { LeasingFeatureConfig } from '../types/LeasingFeatureConfig';
import { dashboard } from './dashboard/CZ';
import { overview } from './overview/CZ';
import { productInfoBox } from './productInfoBox/CZ';

export const leasing: LeasingFeatureConfig = {
    defaultRoute: 'overview',
    relyOnWebAPIAlias: false,
    dashboard,
    overview,
    productInfoBox,
};
